module.exports = __webpack_public_path__ + "img/rule1.2cfebc78.png";